<template>
  <div class="container-fluid"
       :class="{'first-view': page === 'first'}">
    <Breadcrumb v-if="page !== 'first'" :values="{ Home: '/', 'Group Comparison': '' }"></Breadcrumb>
    <img v-if="page === 'first'" class="logo" :src="logo"/>
    <div v-if="firstQuery.filters && secondQuery.filters" class="animated fadeIn w-100" :class="{'animated-style': page === 'first'}" :style="page === 'first' ? 'width: 100%; max-width: 1300px' : 'min-height: 100%;'">
      <div class="card view-wrapper">
        <div v-if="page === 'first'" class="card-body view">
          <Loader :show="loading" :fixed="false" style="z-index: 9;"/>
          <div class="header">
            <div class="title">
              <!--          <font-awesome-icon icon="trophy" size="4x"></font-awesome-icon>-->
              <div>Group Comparison</div>
            </div>
            <div class="steps">
              <el-steps :active="0" finish-status="success">
                <el-step title="Step 1"></el-step>
              </el-steps>
            </div>
          </div>
          <div class="form-wrapper">
            <div class="d-flex flex-column justify-content-center w-100">
              <div>
                <el-radio-group v-model="showFirstGroup" class="best-worst-switch">
                  <el-radio-button :label="true">Group 1</el-radio-button>
                  <el-radio-button :label="false">Group 2</el-radio-button>
                </el-radio-group>
              </div>
              <template v-if="showFirstGroup">
                <span class="subtitle">Please, select the criteria to define Group 1:</span>
                <div class="form-group d-flex align-items-center justify-content-center flex-wrap">
                  <el-select
                      v-model="firstQuery.filters.essentials.businessUnit.value"
                      placeholder="Select business unit" filterable multiple collapse-tags @change="updateDropdownValues(firstQuery)"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('product_area')"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-select
                      v-model="firstQuery.filters.essentials.category.value"
                      placeholder="Select category" filterable multiple collapse-tags @change="updateDropdownValues(firstQuery)"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('category')"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-select
                      v-model="firstQuery.filters.essentials.product.value"
                      placeholder="Select product" filterable multiple collapse-tags @change="updateDropdownValues(firstQuery)"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('product_type')"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-select
                      v-model="firstQuery.filters.essentials.client.value"
                      placeholder="Select client" filterable multiple collapse-tags @change="updateDropdownValues(firstQuery)"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('client')"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-select :value="firstQuery.filters.essentials.region.value" @change="changeFirstQueryRegionData"
                             placeholder="Select region of the study" multiple filterable collapse-tags>
                    <el-option-group label="Press Tab/Escape to exit">
                      <template v-for="value in getMetadataTagValues('region')">
                        <el-option v-if="!['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(value.value)"
                                   :key="value.value" :label="value.value"
                                   :value="value.value">
                          <span style="float: left">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                      </template>
                      <template v-for="value in getASPACcounts()">
                        <el-option v-if="value.value === 'APAC' && value.count" :key="value.value" :label="value.value"
                                   :value="value.value">
                          <span style="float: left">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                        <el-option v-else-if="value.count" :key="value.value" :label="value.value"
                                   :value="value.value">
                          <span style="float: left; margin-left: 10px">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                      </template>
                    </el-option-group>
                  </el-select>
                  <el-input
                      v-model="firstQuery.filters.fragranceDetails.fragranceName.value"
                      placeholder="Insert fragrance name" clearable @change="updateDropdownValues(firstQuery)"
                  >
                  </el-input>
                </div>
                <div class="row d-flex justify-content-center" style="align-items: center;">
                  <div class="col-lg-4 col-md-4 input-wrapper">
                    <div class="slider-wrapper">
                      <el-slider
                          v-if="Object.keys(firstQuery.yearInput).length"
                          v-model="firstQuery.yearInput.value"
                          range
                          :min="firstQuery.yearInput.min"
                          :max="firstQuery.yearInput.max"
                          :marks="firstQuery.yearInput.marks"
                          @change="[parseQueryYear(firstQuery), updateDropdownValues(firstQuery)]"
                          show-stops
                      >
                      </el-slider>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <span class="subtitle">Please, select the criteria to define Group 2:</span>
                <div class="form-group d-flex align-items-center justify-content-center flex-wrap">
                  <el-select
                      v-model="secondQuery.filters.essentials.businessUnit.value"
                      placeholder="Select business unit" filterable multiple collapse-tags @change="updateDropdownValues(secondQuery)"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('product_area', true)"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-select
                      v-model="secondQuery.filters.essentials.category.value"
                      placeholder="Select category" filterable multiple collapse-tags @change="updateDropdownValues(secondQuery)"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('category', true)"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-select
                      v-model="secondQuery.filters.essentials.product.value"
                      placeholder="Select product" filterable multiple collapse-tags @change="updateDropdownValues(secondQuery)"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('product_type', true)"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-select
                      v-model="secondQuery.filters.essentials.client.value"
                      placeholder="Select client" filterable multiple collapse-tags @change="updateDropdownValues(secondQuery)"
                  >
                    <el-option-group label="Press Tab/Escape to exit">
                      <el-option
                          v-for="value in getMetadataTagValues('client', true)"
                          :key="value.value" :label="value.value" :value="value.value">
                        <span style="float: left">{{value.value}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-select :value="secondQuery.filters.essentials.region.value"
                             @change="changeSecondQueryRegionData" collapse-tags
                             placeholder="Select region of the study" multiple filterable>
                    <el-option-group label="Press Tab/Escape to exit">
                      <template v-for="value in getMetadataTagValues('region', true)">
                        <el-option v-if="!['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(value.value)"
                                   :key="value.value" :label="value.value"
                                   :value="value.value">
                          <span style="float: left">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                      </template>
                      <template v-for="value in getASPACcounts()">
                        <el-option v-if="value.value === 'APAC'" :key="value.value" :label="value.value"
                                   :value="value.value">
                          <span style="float: left">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                        <el-option v-else :key="value.value" :label="value.value"
                                   :value="value.value">
                          <span style="float: left; margin-left: 10px">{{value.value}}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                        </el-option>
                      </template>
                    </el-option-group>
                  </el-select>
                  <el-input
                      v-model="secondQuery.filters.fragranceDetails.fragranceName.value"
                      placeholder="Insert fragrance name" clearable @change="updateDropdownValues(secondQuery)"
                  >
                  </el-input>
                </div>
                <div class="row d-flex justify-content-center" style="align-items: center;">
                  <div class="col-lg-4 col-md-4 input-wrapper">
                    <div class="slider-wrapper">
                      <el-slider
                          v-if="Object.keys(secondQuery.yearInput).length"
                          v-model="secondQuery.yearInput.value"
                          range
                          :min="secondQuery.yearInput.min"
                          :max="secondQuery.yearInput.max"
                          :marks="secondQuery.yearInput.marks"
                          @change="[parseQueryYear(secondQuery), updateDropdownValues(secondQuery)]"
                          show-stops
                      >
                      </el-slider>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div>
            <div class="d-flex justify-content-end">
              <button class="btn next-button" @click="nextPage()">Compare</button>
            </div>
            <div class="footnote">
            </div>
          </div>
        </div>
        <div v-else class="card-body d-flex flex-column" style="position: relative; padding: 0;">
          <Loader :show="loading" :fixed="false"/>
          <div class="group-comparison-banner">
            <div class="banner-text">
              Group Comparison
            </div>
          </div>
          <div class="d-flex flex-row">
            <div class="d-flex flex-row justify-content-between" style="margin-top: 5px; height: 100%; width: 100%;">
              <div class="results-box" style="margin-right: 125px;">
                <div class="row align-items-center justify-content-center mx-2 mb-4">
                  <div class="col-6 d-flex flex-column align-items-center">
                    <div class="input-wrapper mt-2">
                      <label>Ethnicity</label>
                      <el-select
                          v-model="firstQuery.filters.demographics.ethnicity.value"
                          placeholder="Select values" @change="updateDropdownValues(firstQuery)"
                      >
                        <el-option-group label="Press Tab/Escape to exit">
                          <el-option
                              v-for="value in getDemographicsTagValues('ethnicity')"
                              :key="value" :label="value" :value="value">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </div>
                  </div>
<!--                  <div class="col-6 d-flex flex-column align-items-center">-->
<!--                    <div class="input-wrapper mt-2">-->
<!--                      <label>Social class</label>-->
<!--                      <el-select-->
<!--                          v-model="firstQuery.filters.demographics.socialClass.value"-->
<!--                          placeholder="Select values" @change="updateDropdownValues(firstQuery)"-->
<!--                      >-->
<!--                        <el-option-group label="Press Tab/Escape to exit">-->
<!--                          <el-option-->
<!--                              v-for="value in getDemographicsTagValues('social_class')"-->
<!--                              :key="value.label" :label="value.label" :value="value.label">-->
<!--                          </el-option>-->
<!--                        </el-option-group>-->
<!--                      </el-select>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="col-6 d-flex flex-column align-items-center">
                    <div class="input-wrapper mt-2">
                      <label>Gender</label>
                      <el-select
                          v-model="firstQuery.filters.demographics.gender.value"
                          placeholder="Select values" @change="updateDropdownValues(firstQuery)"
                      >
                        <el-option-group label="Press Tab/Escape to exit">
                          <el-option
                              v-for="value in getDemographicsTagValues('gender')"
                              :key="value" :label="value" :value="value">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </div>
                  </div>
<!--                  <div class="col-6 d-flex flex-column align-items-center">-->
<!--                    <div class="input-wrapper mt-2">-->
<!--                      <label>Brands Used Most Often (BUMO)</label>-->
<!--                      <el-select-->
<!--                          v-model="firstQuery.filters.demographics.bumo.value"-->
<!--                          placeholder="Select values" filterable disabled @change="updateDropdownValues(firstQuery)"-->
<!--                      >-->
<!--                        <el-option-group label="Press Tab/Escape to exit">-->
<!--                          <el-option-->
<!--                              v-for="value in getDemographicsTagValues('bumo')"-->
<!--                              :key="value" :label="value" :value="value">-->
<!--                          </el-option>-->
<!--                        </el-option-group>-->
<!--                      </el-select>-->
<!--                    </div>-->

<!--                  </div>-->
                  <div class="col-12 mb-2 d-flex flex-column align-items-center">
                    <div class="input-wrapper mt-2">
                      <label>Age</label>
                      <div class="slider-wrapper">
                        <el-slider
                            v-if="Object.keys(firstQuery.ageInput).length"
                            v-model="firstQuery.ageInput.value"
                            range
                            :min="firstQuery.ageInput.min"
                            :max="firstQuery.ageInput.max"
                            :marks="createSliderBreakpoints(firstQuery.ageInput.min, firstQuery.ageInput.max, 5)"
                            @change="[parseQueryAge(firstQuery), updateDropdownValues(firstQuery)]"
                        >
                        </el-slider>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tags-container">
                  <CurrentTags :filters="firstQuery.filters" :remove-applied-filter="tag => removeAppliedFilter(tag, firstQuery)"
                               :remove-metric="idx => removeMetric(idx, firstQuery)" show></CurrentTags>
                </div>
                <div class="table-toggle" @click="toggleDrawers">List of Fragrances</div>
                <div class="table-container" :class="{opened: listsOpened}">
                  <template v-if="filteredFirstQueryData.length">
                    <template v-for="(item, id) in filteredFirstQueryData">
                      <div
                          :key="`first-item-${id}`"
                          class="data data-hide d-flex flex-row justify-content-between align-items-center">
                        <div class="w-75 d-flex align-items-start"
                             v-if="item.prod">
                          <b-tooltip v-if="showTooltip" class="checkbox-tooltip" :target="`first-checkbox-tooltip-${item.id}`" placement="right">
                              {{formatValue(item.c_mi_number)}}
                              <br>
                              {{ formatValue(item.category) }}
                              <br>
                              {{ item.name || item.prod }}
                          </b-tooltip>
                          <Checkbox :color="'purple'" style="width: 100%"
                                    :id="`first-checkbox-tooltip-${item.id}`"
                                    :value="firstQuery.selectedProducts[item.study_id]">
                            <span>{{item.name || item.prod}}</span>
                          </Checkbox>
                          <router-link
                              style="margin-left: 5px;"
                              :to="{name: 'fragrance-profile', params: { id: item.study_id, code: item.prod }} "
                              target="_blank">
                            <font-awesome-icon icon="external-link-alt"/>
                          </router-link>
                        </div>
                        <span v-else>{{ formatValue(item.product) }}</span>
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex justify-content-center align-items-center" style="width: 35px;" v-for="metric in parsedFirstQueryMetrics" :key="`${metric} – ${item.id}`">
                            {{ getMetricValue(item, metric) }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <span v-else><i>No Fragrances found matching this query</i></span>
                </div>
                <div class="d-flex flex-row flex-wrap justify-content-center"
                     style="width: 100%; margin: 20px 0;">
                  <template v-if="finished">
                    <template v-if="Object.keys(firstQuery.chartData).length">
                      <HorizontalAnalyticsChart v-for="(item, idx) in firstQuery.chartData"
                                                style="width: 90%; margin: 10px 0;"
                                                :style="`order: ${getChartOrder(idx)}`"
                                                :key="`chart-${idx}`" :max="100"
                                                :data="item.data" :mean="item.mean"></HorizontalAnalyticsChart>
                    </template>
                    <template v-else>
                      <span>No results for specific query</span>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row-reverse justify-content-between"
                 style="margin-top: 5px; height: 100%; width: 100%;">
              <div class="results-box">
                <div class="row align-items-center justify-content-center mx-2 mb-4">
                  <div class="col-6 d-flex flex-column align-items-center">
                    <div class="input-wrapper mt-2">
                      <label>Ethnicity</label>
                      <el-select
                          v-model="secondQuery.filters.demographics.ethnicity.value"
                          placeholder="Select values" @change="updateDropdownValues(secondQuery)"
                      >
                        <el-option-group label="Press Tab/Escape to exit">
                          <el-option
                              v-for="value in getDemographicsTagValues('ethnicity')"
                              :key="value" :label="value" :value="value">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </div>
                  </div>
<!--                  <div class="col-6 d-flex flex-column align-items-center">-->
<!--                    <div class="input-wrapper mt-2">-->
<!--                      <label>Social class</label>-->
<!--                      <el-select-->
<!--                          v-model="secondQuery.filters.demographics.socialClass.value"-->
<!--                          placeholder="Select values" @change="updateDropdownValues(secondQuery)"-->
<!--                      >-->
<!--                        <el-option-group label="Press Tab/Escape to exit">-->
<!--                          <el-option-->
<!--                              v-for="value in getDemographicsTagValues('social_class')"-->
<!--                              :key="value.label" :label="value.label" :value="value.label">-->
<!--                          </el-option>-->
<!--                        </el-option-group>-->
<!--                      </el-select>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="col-6 d-flex flex-column align-items-center">
                    <div class="input-wrapper mt-2">
                      <label>Gender</label>
                      <el-select
                          v-model="secondQuery.filters.demographics.gender.value"
                          placeholder="Select values" @change="updateDropdownValues(secondQuery)"
                      >
                        <el-option-group label="Press Tab/Escape to exit">
                          <el-option
                              v-for="value in getDemographicsTagValues('gender')"
                              :key="value" :label="value" :value="value">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </div>
                  </div>
<!--                  <div class="col-6 d-flex flex-column align-items-center">-->
<!--                    <div class="input-wrapper mt-2">-->
<!--                      <label>Brands Used Most Often (BUMO)</label>-->
<!--                      <el-select-->
<!--                          v-model="secondQuery.filters.demographics.bumo.value"-->
<!--                          placeholder="Select values" filterable disabled @change="updateDropdownValues(secondQuery)"-->
<!--                      >-->
<!--                        <el-option-group label="Press Tab/Escape to exit">-->
<!--                          <el-option-->
<!--                              v-for="value in getDemographicsTagValues('bumo')"-->
<!--                              :key="value" :label="value" :value="value">-->
<!--                          </el-option>-->
<!--                        </el-option-group>-->
<!--                      </el-select>-->
<!--                    </div>-->

<!--                  </div>-->
                  <div class="col-12 mb-2 d-flex flex-column align-items-center">
                    <div class="input-wrapper mt-2">
                      <label>Age</label>
                      <div class="slider-wrapper">
                        <el-slider
                            v-if="Object.keys(secondQuery.ageInput).length"
                            v-model="secondQuery.ageInput.value"
                            range
                            :min="secondQuery.ageInput.min"
                            :max="secondQuery.ageInput.max"
                            :marks="createSliderBreakpoints(secondQuery.ageInput.min, secondQuery.ageInput.max, 5)"
                            @change="[parseQueryAge(secondQuery), updateDropdownValues(secondQuery)]"
                        >
                        </el-slider>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tags-container">
                  <CurrentTags :filters="secondQuery.filters" :remove-applied-filter="tag => removeAppliedFilter(tag, secondQuery)"
                               :remove-metric="idx => removeMetric(idx, secondQuery)" show></CurrentTags>
                </div>
                <div class="table-toggle" @click="toggleDrawers">List of studies</div>
                <div class="table-container" :class="{opened: listsOpened}">
                  <template v-if="filteredSecondQueryData.length">
                    <template v-for="(item, id) in filteredSecondQueryData">
                      <div
                          :key="`second-item-${id}`"
                          class="data data-hide d-flex flex-row justify-content-between align-items-center">
                        <div class="w-75 d-flex align-items-start"
                             v-if="item.prod">
                          <b-tooltip v-if="showTooltip"  class="checkbox-tooltip" :target="`second-checkbox-tooltip-${item.id}`" placement="right">
                              {{formatValue(item.c_mi_number)}}
                              <br>
                              {{ formatValue(item.category) }}
                              <br>
                              {{ item.name || item.prod }}
                          </b-tooltip>
                          <Checkbox :color="'purple'" style="width: 100%"
                                    :id="`second-checkbox-tooltip-${item.id}`"
                                    :value="secondQuery.selectedProducts[item.study_id]">
                            <span>{{item.name || item.prod}}</span>
                          </Checkbox>
                          <router-link
                              style="margin-left: 5px;"
                              :to="{name: 'fragrance-profile', params: { id: item.study_id, code: item.prod }} "
                              target="_blank">
                            <font-awesome-icon icon="external-link-alt"/>
                          </router-link>
                        </div>
                        <span v-else>{{ formatValue(item.product) }}</span>
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex justify-content-center align-items-center" style="width: 35px;" v-for="metric in parsedSecondQueryMetrics" :key="`${metric} – ${item.id}`">
                            {{ getMetricValue(item, metric) }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <span v-else><i>No studies found matching this query</i></span>
                </div>
                <div class="d-flex flex-row flex-wrap justify-content-center"
                     style="width: 100%; margin: 20px 0;">
                  <template v-if="finished">
                    <template v-if="Object.keys(secondQuery.chartData).length">
                      <HorizontalAnalyticsChart v-for="(item, idx) in secondQuery.chartData"
                                                style="width: 90%; margin: 10px 0;"
                                                :style="`order: ${getChartOrder(idx)}`"
                                                :key="`chart-${idx}`" :max="100"
                                                :data="item.data" :mean="item.mean"></HorizontalAnalyticsChart>
                    </template>
                    <template v-else>
                      <span>No results for specific query</span>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div style="position: absolute; top: 200px; left: calc(50% - 80px);">
            <button class="filter-button" @click="search">Compare</button>
          </div>
          <div style="position: absolute; top: 280px; left: calc(50% - 80px);">
            <button class="prev-button" @click="previousPage">Back</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilsFunctions from '../helpers/utilsFunctions'
import HorizontalAnalyticsChart from '../components/shared/HorizontalAnalyticsChart'
import studyActions from '../store/modules/studies/actionTypes'
import { mapActions, mapGetters } from 'vuex'
import studyGetters from '../store/modules/studies/getterTypes'
import getInitialFilters from '../constants/searchFilters'
import _ from 'lodash'
import Breadcrumb from '../components/shared/Breadcrumb'
import Checkbox from '../components/shared/Checkbox'
import CurrentTags from '../components/shared/CurrentTags'
import generalActions from '../store/modules/general/actionTypes'
import logo from '../assets/images/logos/Iris-Grey.svg'
import Loader from '../components/shared/Loader'
import searchFunctions from '../helpers/searchFunctions'

export default {
  name: 'GroupComparison',
  components: { Loader, CurrentTags, Checkbox, HorizontalAnalyticsChart, Breadcrumb },
  data () {
    return {
      listsOpened: true,
      showTooltip: false,
      firstQuery: {
        filters: null,
        ageInput: {
          min: 18,
          max: 64,
          value: [18, 64],
          marks: {
            18: '18',
            64: '64'
          }
        },
        previousRegionValues: [],
        yearInput: {},
        fields: [],
        data: {},
        selectedProducts: {},
        interval: null,
        finished: true,
        chartData: null
      },
      secondQuery: {
        filters: null,
        ageInput: {
          min: 18,
          max: 64,
          value: [18, 64],
          marks: {
            18: '18',
            64: '64'
          }
        },
        previousRegionValues: [],
        yearInput: {},
        fields: [],
        data: {},
        selectedProducts: {},
        interval: null,
        finished: true,
        chartData: null
      },
      page: 'first',
      showFirstGroup: true,
      sortBy: 'id',
      analyticsFields: {},
      order: ['top_box', 'top_2_box', 'just_right', 'mean', 'bottom_2_box', 'bottom_box'],
      aggsNotForChart: ['mean', 'bottom_box', 'top_box', 'irt_yes', 'irt_no', 'hi_yes', 'hi_no', 'eeg_mean', 'variance'],
      metricsToDisplayItem: ['liking.top_2_box'],
      logo,
      createSliderBreakpoints: utilsFunctions.createSliderBreakpoints
    }
  },
  computed: {
    ...mapGetters({
      fields: studyGetters.GET_FIELDS
    }),
    filteredFirstQueryData () {
      const arrayCopy = this.formatData(this.firstQuery.data.results)
      return arrayCopy.sort((a, b) => {
        if (a[this.sortBy] < b[this.sortBy]) {
          return -1
        }
        if (a[this.sortBy] > b[this.sortBy]) {
          return 1
        }
        return 0
      })
    },
    filteredSecondQueryData () {
      const arrayCopy = this.formatData(this.secondQuery.data.results)
      return arrayCopy.sort((a, b) => {
        if (a[this.sortBy] < b[this.sortBy]) {
          return -1
        }
        if (a[this.sortBy] > b[this.sortBy]) {
          return 1
        }
        return 0
      })
    },
    parsedFirstQueryMetrics () {
      let metricList = []
      this.firstQuery.data.results.forEach(el => {
        const list = Object.keys(el).filter(key => typeof el[key] === 'number' && key !== 'prod')
        list.forEach(label => {
          if (!metricList.includes(label)) {
            metricList.push(label)
          }
        })
      })
      metricList = metricList.filter(metric => this.metricsToDisplayItem.includes(metric))
      return metricList
    },
    parsedSecondQueryMetrics () {
      let metricList = []
      this.secondQuery.data.results.forEach(el => {
        const list = Object.keys(el).filter(key => typeof el[key] === 'number' && key !== 'prod')
        list.forEach(label => {
          if (!metricList.includes(label)) {
            metricList.push(label)
          }
        })
      })
      metricList = metricList.filter(metric => this.metricsToDisplayItem.includes(metric))
      return metricList
    },
    yearsList () {
      return this.getMetadataTagValues('year').map(el => parseInt(el.value))
    },
    finished () {
      return this.firstQuery.finished && this.secondQuery.finished
    },
    loading () {
      return !this.finished
    }
  },
  methods: {
    ...mapActions({
      getMetrics: studyActions.CHECK_METRIC_JOB_STATUS_AND_GET_DATA,
      getAnalyticsFields: studyActions.UPDATE_METRICS_DROPDOWN_OPTIONS,
      getFields: studyActions.FETCH_FIELDS,
      getUpdatedDropdownValues: studyActions.UPDATE_METRICS_DROPDOWN_OPTIONS,
      queueMetricSearch: studyActions.QUEUE_METRIC_SEARCH_AND_GET_JOB_ID,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    formatData (data) {
      const formattedArray = []
      if (data && data.length) {
        data.forEach((el, idx) => {
          formattedArray.push({
            study_id: el.id,
            ...el,
            id: idx
          })
        })
      }
      return formattedArray
    },
    parseChartData (metricResultData) {
      const summ = metricResultData.data.summary
      const parsedData = {}
      Object.keys(summ).forEach(el => {
        parsedData[el] = Object.keys(summ[el]).map(key => {
          return { key, value: summ[el][key] }
        })
      })
      const chartData = {}
      Object.keys(parsedData).forEach(el => {
        if (Object.keys(parsedData[el]).length) {
          const mean = parsedData[el].find(val => val.key === 'mean').value
          const filteredData = parsedData[el].filter(val => !this.aggsNotForChart.includes(val.key) && !val.key.includes('.count')).reverse()
          const labels = filteredData.map(val => this.formatChartLabel(val.key))
          if (el !== 'strength') {
            labels[labels.indexOf('Just right')] = 'Neutral'
          }
          const data = filteredData.map(val => val.value)
          chartData[el] = {
            mean,
            data: {
              labels,
              datasets: [
                {
                  label: this.formatChartLabel(el),
                  backgroundColor: '#A3A0FB80',
                  data
                }
              ]
            }
          }
        }
      })
      return chartData
    },
    formatValue (value) {
      if (!value || value === 'No Tag') {
        return '-'
      } else if (typeof value === 'string') {
        return value && value.charAt(0).toUpperCase() + value.slice(1)
      } else {
        return value
      }
    },
    formatChartLabel (value) {
      return value.charAt(0).toUpperCase() + value.slice(1).replace(/_+/g, ' ')
    },
    getMetricValue (obj, metric) {
      const metricFilter = metric.split('.')
      if (metricFilter.length < 2) {
        return obj[metric] ? obj[metric] : '-'
      }
      if (metricFilter[1] === 'mean') {
        return obj[metric] ? obj[metric].toFixed(2) : '-'
      } else {
        return obj[metric] ? `${Math.round(obj[metric])}%` : '-'
      }
    },
    getMetricLabel (metric) {
      const metricRange = this.filterFields.metrics_range
      const metricFilter = metric.split('.')
      if (metricFilter[1] === 'mean') {
        const range = `[${metricRange[metricFilter[0]][0]}-${metricRange[metricFilter[0]][1]}]`
        return `${metricFilter[0]}, ${metricFilter[1]} ${range}`.replace(/_+/g, ' ')
      }
      return `${metricFilter[0]}, ${metricFilter[1]} [%]`.replace(/_+/g, ' ')
    },
    getMetadataTagValues (tag, isSecondGroup = false) {
      if (this.firstQuery.fields.length || (isSecondGroup && this.secondQuery.fields.length)) {
        const data = isSecondGroup ? this.secondQuery.fields[0].data : this.firstQuery.fields[0].data
        const tags = data.find(el => el.field === tag)
        return tags ? tags.options : []
      }
      return []
    },
    getDemographicsTagValues (tag) {
      const analyticsData = this.analyticsFields.find(el => el.group_label === 'analytics').data
      const aggregationData = analyticsData.find(el => el.group_label === 'aggregation').data
      const demographicsData = aggregationData.demographics
      if (demographicsData && Object.keys(demographicsData).length) {
        return demographicsData[tag] || []
      }
      return []
    },
    getASPACcounts (isSecondGroup = false) {
      if (this.firstQuery.fields.length || (isSecondGroup && this.secondQuery.fields.length)) {
        const data = isSecondGroup ? this.secondQuery.fields[0].data : this.firstQuery.fields[0].data
        const tags = data.find(el => el.field === 'region')
        if (tags) {
          const filteredValues = tags.options.filter(el => ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(el.value))
          const counts = filteredValues.map(el => el.count)
          const count = counts.reduce((a, b) => {
            return a + b
          }, 0)
          const aspacObj = { value: 'APAC', count }
          filteredValues.push(aspacObj)
          return filteredValues.sort((a, b) => {
            return a.value > b.value ? 1 : a.value < b.value ? -1 : 0
          })
        }
      }
      return []
    },
    getChartOrder (tag) {
      switch (tag) {
        case 'liking':
          return 2
        case 'strength':
          return 4
        case 'purchase_intention':
          return 3
        default:
          return 1
      }
    },
    changeFirstQueryRegionData (data) {
      const mainRegion = 'APAC'
      const subRegions = ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia']
      if (data.includes(mainRegion)) {
        if (!this.firstQuery.previousRegionValues.includes(mainRegion)) {
          data = [...new Set([...data, ...subRegions])]
        } else {
          if (data.filter(el => el !== mainRegion).length < 3) {
            const index = data.indexOf(mainRegion)
            data.splice(index, 1)
          }
        }
      } else {
        if (this.firstQuery.previousRegionValues.includes(mainRegion)) {
          data = data.filter(x => !subRegions.includes(x))
        }
      }
      this.$set(this.firstQuery.filters.essentials.region, 'value', data)
      this.firstQuery.previousRegionValues = data
      this.updateDropdownValues(this.firstQuery)
    },
    changeSecondQueryRegionData (data) {
      const mainRegion = 'APAC'
      const subRegions = ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia']
      if (data.includes(mainRegion)) {
        if (!this.secondQuery.previousRegionValues.includes(mainRegion)) {
          data = [...new Set([...data, ...subRegions])]
        } else {
          if (data.filter(el => el !== mainRegion).length < 3) {
            const index = data.indexOf(mainRegion)
            data.splice(index, 1)
          }
        }
      } else {
        if (this.secondQuery.previousRegionValues.includes(mainRegion)) {
          data = data.filter(x => !subRegions.includes(x))
        }
      }
      this.$set(this.secondQuery.filters.essentials.region, 'value', data)
      this.secondQuery.previousRegionValues = data
      this.updateDropdownValues(this.secondQuery)
    },
    previousPage () {
      this.showTooltip = false
      this.page = 'first'
    },
    async updateDropdownValues (queryObj) {
      const data = searchFunctions.parseDataForSearch(_.cloneDeep(queryObj.filters))
      const parsedQuery = data.query
      const res = await this.getUpdatedDropdownValues({ query: parsedQuery, query_metrics: {} })
      queryObj.fields = res.data.fields
    },
    async nextPage () {
      this.showTooltip = true
      this.firstQuery.finished = false
      this.secondQuery.finished = false
      await this.createSearchForQuery(this.firstQuery, false)
      await this.createSearchForQuery(this.secondQuery, false)
    },
    async search () {
      this.firstQuery.finished = false
      this.secondQuery.finished = false
      await this.createSearchForQuery(this.firstQuery, true)
      await this.createSearchForQuery(this.secondQuery, true)
    },
    async createSearchForQuery (queryObj, filterByFrags = false) {
      queryObj.filters.metrics.metricsList = [{
        metricType: { label: 'Metric type', key: 'metric_type', value: 'performance' },
        metric: { label: 'Metric', key: 'metric', value: 'liking' },
        aggregation: { label: 'Aggregation', key: 'aggregation', value: 'top_2_box' },
        confidence: { label: 'Confidence', key: 'confidence', value: false }
      }]
      if (filterByFrags) {
        const fragrances = queryObj.data.results.map(fragrance => ({
          prod: fragrance.prod,
          c_mi_number: fragrance.c_mi_number,
          id: fragrance.id
        })).filter(fragrance => Object.keys(queryObj.selectedProducts).includes(fragrance.id))
        const queryRequestObj = searchFunctions.parseDataForSearch(queryObj.filters)
        queryRequestObj['demographics_fragrances'] = queryRequestObj['demographics']
        queryObj.jobId = await this.queueMetricSearch({
          q: queryRequestObj,
          data: fragrances
        })
      } else {
        const queryRequestObj = searchFunctions.parseDataForSearch(queryObj.filters)
        queryObj.jobId = await this.queueMetricSearch({
          q: queryRequestObj
        })
      }
      queryObj.interval = setInterval(async () => {
        const data = await this.getMetrics(queryObj.jobId)
        if (data) {
          queryObj.data = data.result.json
          queryObj.chartData = this.parseChartData(queryObj)
          queryObj.finished = true
          clearInterval(queryObj.interval)
        }
      }, 3000)
    },
    parseQueryAge (queryObj) {
      queryObj.filters.demographics.startAge.value = queryObj.ageInput.value[0]
      queryObj.filters.demographics.endAge.value = queryObj.ageInput.value[1]
    },
    parseQueryYear (queryObj) {
      queryObj.filters.essentials.startYear.value = queryObj.yearInput.value[0]
      queryObj.filters.essentials.endYear.value = queryObj.yearInput.value[1]
    },
    toggleDrawers () {
      this.listsOpened = !this.listsOpened
    },
    removeMetric (index, queryObj) {
      const metricsList = queryObj.filters.metrics.metricsList
      if (metricsList.length > 1) {
        metricsList.splice(index, 1)
      } else {
        this.$set(queryObj.filters.metrics.metricsList, index, getInitialFilters.getEmptyMetric())
      }
    },
    removeAppliedFilter (tag, queryObj) {
      switch (tag.key) {
        case 'year':
          if (queryObj.yearInput.value) {
            this.$set(queryObj.yearInput, 'value', [queryObj.yearInput.min, queryObj.yearInput.value[1]])
            this.$set(queryObj.yearInput, 'value', [queryObj.yearInput.value[0], queryObj.yearInput.max])
            queryObj.filters.essentials.startYear.value = ''
            queryObj.filters.essentials.endYear.value = ''
          }
          break
        case 'age':
          queryObj.filters.essentials.startYear.value = ''
          queryObj.filters.essentials.endYear.value = ''
          break
        // case 'socialClass':
        //   this.$set(queryObj.filters.demographics.socialClass, 'value', '')
        //   break
        case 'threshold':
          this.$set(queryObj.filters.metrics.threshold, 'applyThreshold', false)
          break
        default:
          Object.keys(queryObj.filters).forEach(category => {
            const filter = Object.values(queryObj.filters[category]).find(el => el.label === tag.label)
            if (filter) {
              filter.value = ''
            }
          })
      }
    }
  },
  async beforeMount () {
    this.toggleLoading(true)
    this.analyticsFields = (await this.getAnalyticsFields({ query: [], query_metrics: [] })).data.fields
    this.firstQuery.filters = _.cloneDeep(getInitialFilters.getInitialFilters())
    this.firstQuery.fields = _.cloneDeep(this.analyticsFields)
    this.secondQuery.filters = _.cloneDeep(getInitialFilters.getInitialFilters())
    this.secondQuery.fields = _.cloneDeep(this.analyticsFields)
    this.toggleLoading(false)
  },
  beforeDestroy () {
    this.showTooltip = false
  },
  watch: {
    'firstQuery.data' (newData) {
      newData.results.forEach(fragrance => {
        this.firstQuery.selectedProducts[fragrance.id] = true
      })
    },
    'secondQuery.data' (newData) {
      newData.results.forEach(fragrance => {
        this.secondQuery.selectedProducts[fragrance.id] = true
      })
    },
    yearsList (newValue) {
      if (newValue.length) {
        const min = Math.min(...this.yearsList)
        const max = Math.max(...this.yearsList)
        const yearInput = {
          min,
          max,
          marks: {},
          includeMissing: true
        }
        yearInput.marks[min] = min.toString()
        yearInput.marks[max] = max.toString()
        const firstQueryYearInput = _.cloneDeep(yearInput)
        const secondQueryYearInput = _.cloneDeep(yearInput)
        firstQueryYearInput.value = [
          this.firstQuery.yearInput.value ? this.firstQuery.yearInput.value[0] : min,
          this.firstQuery.yearInput.value ? this.firstQuery.yearInput.value[1] : max
        ]
        secondQueryYearInput.value = [
          this.secondQuery.yearInput.value ? this.secondQuery.yearInput.value[0] : min,
          this.secondQuery.yearInput.value ? this.secondQuery.yearInput.value[1] : max
        ]
        this.firstQuery.yearInput = firstQueryYearInput
        this.secondQuery.yearInput = secondQueryYearInput
      }
    },
    loading (newData) {
      if (!newData) {
        this.page = 'second'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

hr.space {
  margin: 1.5em 0;
  visibility: hidden;
}

.container-fluid.first-view {
  padding: 99px 87px !important;
  background-image: url("../assets/images/backgrounds/IRIS-background-720p.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-fluid {
  height: 100%;
}

.view-wrapper {
  background-color: rgba(255, 255, 255, 0.93);
  height: 100%;
  border: 0;
  margin: 0;
}

.results-box {
  width: calc(100% - 125px);
}

.table-container {
  height: 0;
  width: calc(100% - 60px);
  overflow-y: scroll;
  border: 1px solid #707070;
  margin: 0 30px;
  transition: height 0.2s linear;

  &.opened {
    height: 600px;
  }
}

.table-toggle {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
  height: 30px;
  width: calc(100% - 60px);
  border: 1px solid #707070;
  margin: 0 30px;
  background-color: rgba(192, 196, 204, 0.15);
  border-bottom: 0;
  cursor: pointer;
}

.group-comparison-banner {
  background: transparent linear-gradient(266deg, rgba(115,178,224, 0.73) 0%, rgba(0,39,204, 0.73) 100%) 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  border: 1px solid #231A44;
  border-left: 0;
  border-right: 0;
  height: 130px;
  width: 100%;

  .banner-text {
    margin-top: 9px;
    margin-left: 38px;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 900;
    font-size: 45px;
    line-height: 56px;
    letter-spacing: 0.9px;
    color: white;
    width: 445px;
    height: 56px;
    text-transform: uppercase;
  }
}

.card {
  margin-bottom: 0;
  border: 0;
  width: 100%;
  background-color: rgba(255,255,255,0.93);
}

.view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 3px 6px #000000;
  padding: 0;
  width: 100%;

  .header {
    display: flex;
    justify-content: space-between;

    .steps {
      max-width: 270px;
      height: 62px;
      margin-top: 20px;
      margin-right: 29px;
    }
  }

  .form-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 33px;
    @media screen and (min-width: $break-lg) {
      font-size: 20px;
      line-height: 38px;
    }
    @media screen and (min-width: $break-xl) {
      font-size: 24px;
      line-height: 43px;
    }
    @media screen and (min-width: $break-xxl) {
      font-size: 28px;
      line-height: 48px;
    }
    letter-spacing: 0;
    color: $dusty-blue;
    margin: 10px 50px;
    @media screen and (min-width: $break-lg) {
      margin: 10px 50px;
    }
    @media screen and (min-width: $break-xl) {
      margin: 15px 50px;
    }
    @media screen and (min-width: $break-xxl) {
      margin: 15px 50px;
    }

    .form-group {
      .el-input {
        margin: 0 5px;
        width: unset !important;
      }
      .el-select {
        margin: 0 5px;
      }
    }

    .first-form-row {
      margin-bottom: 30px;
    }

    .best-worst-switch {
      margin: 5px 0;
      border-radius: 4px;
      box-shadow: 0 1px 4px #00000026;
      .el-radio-button__inner {
        padding: 0 20px;
      }
    }

    .type-switch {
      margin: 0 15px;
      border-radius: 4px;
      box-shadow: 0 1px 4px #00000026;
    }

    .number-input {
      margin-left: 20px;
      width: 98px !important;
      height: 43px !important;
      @media screen and (min-width: $break-lg) {
        height: 47px;
      }
      @media screen and (min-width: $break-xl) {
        height: 51px;
      }
      @media screen and (min-width: $break-xxl) {
        height: 55px;
      }
    }
  }

  .next-button {
    font-family: 'Open Sans', sans-serif;
    font-weight: 900;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    background-color: $blueberry;
    color: white;
    text-transform: uppercase;
    border-radius: 4px;
    margin-right: 30px;
    margin-bottom: 15px;
    width: 160px;
    height: 38px;
    padding: 5px;
    @media screen and (min-width: $break-lg) {
      margin-right: 40px;
      margin-bottom: 20px;
      width: 180px;
      height: 40px;
      padding: 2px;
    }
    @media screen and (min-width: $break-xl) {
      margin-right: 60px;
      margin-bottom: 20px;
      width: 200px;
      height: 42px
    }
    @media screen and (min-width: $break-xxl) {
      margin-right: 80px;
      margin-bottom: 25px;
      width: 240px;
      height: 44px
    }
    transition: background-color 0.2s linear;
    &:hover {
      background-color: #9256D9;
    }
  }
}

.title {
  margin-top: 20px;
  margin-left: 32px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 30px;
  line-height: 24px;
  letter-spacing: 0.8px;
  @media screen and (min-width: $break-lg) {
    font-size: 35px;
    line-height: 26px;
    letter-spacing: 0.8px;
    margin-top: 23px;
    margin-left: 37px;
  }
  @media screen and (min-width: $break-xl) {
    font-size: 40px;
    line-height: 28px;
    letter-spacing: 0.9px;
    margin-top: 26px;
    margin-left: 42px;
  }
  @media screen and (min-width: $break-xxl) {
    font-size: 45px;
    line-height: 30px;
    letter-spacing: 0.9px;
    margin-top: 29px;
    margin-left: 47px;
  }
  color: $pewter;
  text-transform: uppercase;
}

.footnote {
  height: 44px;
  background: transparent linear-gradient(268deg, #C961C5 0%, #DEBFDD 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  opacity: 0.9;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (min-width: $break-lg) {
    height: 49px;
    span {
      font-size: 18px;
      line-height: 20px;
      margin-right: 50px;
    }
  }
  @media screen and (min-width: $break-xl) {
    height: 54px;
    span {
      font-size: 18px;
      line-height: 22px;
      margin-right: 55px;
    }
  }
  @media screen and (min-width: $break-xxl) {
    height: 59px;
    span {
      font-size: 20px;
      line-height: 25px;
      margin-right: 60px;
    }
  }
  @media screen and (min-aspect-ratio: 2/1) and (max-height: 800px) {
    height: 40px;
    span {
      font-size: 20px;
      line-height: 25px;
      margin-right: 60px;
    }
  }

  span {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    line-height: 18px;
    color: $charcoal;
    margin-right: 45px;
  }
}

.filter-button {
  width: 160px;
  height: 48px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 900;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0;
  background: #300296;
  color: white;
  text-transform: uppercase;
  border-radius: 4px;

  transition: background-color 0.2s linear;

  &:hover {
    background-color: #9256D9;
  }
}

.prev-button {
  width: 160px;
  height: 48px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 900;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0;
  background: $pewter;
  color: white;
  text-transform: uppercase;
  border-radius: 4px;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
}

.data {
  border-bottom: 1px solid #707070;
  transition: 0.1s background-color linear;
  padding: 0 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  width: 100%;
  cursor: pointer;
}

.data:hover {
  background-color: rgba(192, 196, 204, 0.15);
}

.title svg {
  margin-right: 0.5em;
}
.logo {
  position: fixed;
  bottom: 20px;
  right: 50px;
  width: 6.5%;
  height: auto;
}
</style>
<style lang="scss">
@import "../assets/scss/variables";

.checkbox-tooltip {
  left: 30px !important;
}
.select-group-item {
  .el-input__inner {
    font-family: 'Helvetica', sans-serif;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0;
    color: $default-focus;
    background-color: white !important;
    border: 2px solid #EBEDED !important;
    border-radius: 6px;
  }
}
</style>
